import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Layout,
  Input,
  Button,
  Form,
  Card,
  Divider,
  List,
  Table,
  Dropdown,
  MenuProps,
  Modal,
  Select,
  Radio,
  Image,
  DatePicker,
} from "antd";
import {
  getMetalsService,
  getSalesMaterialsService,
  getBuyersService,
  getSaleService,
} from "../SalesMaterialsPage/SalesMaterialsPageService";
import Loader from "../../components/Loader/Loader";
import "./SalesMaterialsPage.css";
import Sidebar from "../../components/Sidebar/Sidebar";
import Header from "../../components/Header/Header";
import Copyright from "../../components/Copyright/Copyright";
import { removeTokenFromCookies } from "../../utils/cookies";
import {
  FolderOpenOutlined,
  MoreOutlined,
  ReloadOutlined,
  FilterOutlined,
  FilterTwoTone,
  ControlFilled,
} from "@ant-design/icons";
import dayjs from "dayjs";
import moment from "moment";
import Cookies from "universal-cookie";

const { RangePicker } = DatePicker;
const { Content } = Layout;

export interface SalesMaterialsPageInterface {}

const SalesMaterialsPage = (props: SalesMaterialsPageInterface) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [loading, setLoading] = useState(false);
  const [metals, setMetals] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalMaterials, setTotalMaterials] = useState(0);
  const [materialDetailsTableData, setMaterialDetailsTableData] = useState([]) as any;
  const [buyers, setBuyers] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [buyersOptions, setBuyersOptions] = useState([]);
  const [metalsOptions, setMetalsOptions] = useState([]);
  const [buyersSelectedOptions, setBuyersSelectedOptions] = useState("");
  const [metalsSelectedOptions, setMetalsSelectedOptions] = useState("");
  const [dateRangeFilter, setDateRangeFilter] = useState([null, null]) as any;
  const [dateRangeValue, setDateRangeValue] = useState([null, null]) as any;
  const [isFilteredData, setIsFilteredData] = useState(false);
  const [buyersMap, setBuyersMap] = useState({}) as any;
  const [metalsMap, setMetalsMap] = useState({}) as any;
  const materialsColumns = [
    {
      title: "Item Number",
      key: "index",
      align: "center" as const,
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Image",
      key: "index",
      render: (record: any) => (
        <>
          <Image
            height={50}
            width={50}
            src={record.scaleImageURL || record.imageURL}
            preview={{
              toolbarRender: () => (
                <>
                  <h1 style={{ color: "#000000" }}>{metalsMap[record.metalID].displayName}</h1>
                  <h3 style={{ color: "#000000" }}>Raw Weight: {Number(record.rawWeight).toFixed(1)} kg</h3>
                </>
              ),
            }}
          />
          <Image
            height={50}
            width={50}
            src={record.materialImageURL}
            preview={{
              toolbarRender: () => (
                <>
                  <h1 style={{ color: "#000000" }}>{metalsMap[record.metalID].displayName}</h1>
                  <h3 style={{ color: "#000000" }}>Raw Weight: {Number(record.rawWeight).toFixed(1)} kg</h3>
                </>
              ),
            }}
          />
        </>
      ),
      align: "center" as const,
    },
    {
      title: "Date",
      key: "date",
      align: "center" as const,
      render: (record: any) => new Date(record.createdTimestamp).toLocaleDateString("en-GB"),
    },
    {
      title: "Time",
      key: "time",
      align: "center" as const,
      render: (record: any) =>
        new Date(record.createdTimestamp).toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }),
    },
    // {
    //   title: "Buyer",
    //   key: "buyer",
    //   align: "left" as const,
    //   render: (record: any) => getBuyerDisplayName(record.buyerInfo),
    // },
    {
      title: "Material Name",
      key: "materialName",
      align: "left" as const,
      render: (record: any) => metalsMap[record.metalID].displayName,
    },
    {
      title: "Net Weight (kg)",
      key: "netWeight",
      align: "center" as const,
      render: (record: any) => Number(record.netWeight).toFixed(1),
    },
    {
      title: "Unit Price (RM/kg)",
      key: "price",
      align: "center" as const,
      render: (record: any) => Number(record.price).toFixed(2),
    },
    {
      title: "Total Amount (RM)",
      key: "total",
      align: "center" as const,
      render: (record: any) => (Number(record.netWeight) * Number(record.price)).toFixed(2),
    },
    {
      title: "Manual Entry",
      key: "manualEntry",
      align: "center" as const,
      render: (record: any) =>
        record.manualEntry ? (
          <>
            <ControlFilled style={{ fontSize: "20px", color: "orange", marginRight: "5px" }} />
            Yes
          </>
        ) : (
          <>
            <ControlFilled style={{ fontSize: "20px", color: "green", marginRight: "5px" }} />
            No
          </>
        ),
    },
    Table.EXPAND_COLUMN,
    {
      title: "Options",
      key: "options",
      align: "center" as const,
      render: (record: any) => {
        let items: MenuProps["items"] = [{ key: "view", label: "View Sale", icon: <FolderOpenOutlined /> }];
        return (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === "view") viewSale(record.saleInfo.saleID);
              },
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <MoreOutlined style={{ fontSize: "24px" }} />
            </a>
          </Dropdown>
        );
      },
    },
  ];
  const navigate = useNavigate();
  const cookies = new Cookies();
  const currOffice = cookies.get("CURR_OFFICE");

  useEffect(() => {
    navToSelectOffice();
    getMetals();
    getBuyers();
  }, []);

  useEffect(() => {
    getMaterials(currentPage, buyersSelectedOptions, metalsSelectedOptions, dateRangeFilter);
  }, [metals]);

  const navToSelectOffice = () => {
    if (currOffice === "" || currOffice === undefined || currOffice === null) navigate("/");
  };

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const getBuyers = async () => {
    try {
      setLoading(true);
      const res = await getBuyersService();
      const buyersData = currOffice === "pg" ? res.data.pgBuyers : currOffice === "bw" ? res.data.bwBuyers : [];
      setBuyers(buyersData);

      const options: any = [];
      const currBuyersMap: any = {};
      buyersData.forEach((buyer: any) => {
        currBuyersMap[buyer.buyerID] = { ...buyer };
        options.push({
          label: getBuyerDisplayName(buyer),
          value: buyer.buyerID,
        });
      });
      setBuyersOptions(options);
      setBuyersMap(currBuyersMap);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getBuyers error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getBuyersFilterOptions = () => {
    const options: any = [];
    buyers.forEach((buyer: any) => {
      options.push({
        value: buyer.buyerID,
        label:
          buyer.companyName !== "" && buyer.companyName !== undefined
            ? `${buyer.companyName} ( ${buyer.name} )`
            : `${buyer.name}`,
      });
    });
    setBuyersOptions(options);
  };

  const getMetals = async () => {
    try {
      setLoading(true);
      const res = await getMetalsService();
      setMetals(res.data);
      const options: any = [];
      const currMetalsMap: any = {};
      res.data.forEach((metal: any) => {
        currMetalsMap[metal.metalID] = { ...metal };
        options.push({
          label: metal.displayName,
          value: metal.metalID,
        });
      });
      setMetalsOptions(options);
      setMetalsMap(currMetalsMap);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getMetals error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getMaterials = async (
    pageNumber: Number,
    buyersFilter: String,
    metalsFilter: String,
    dateRangeFilter: String[]
  ) => {
    try {
      setLoading(true);
      const filters = {
        buyers: buyersFilter,
        metals: metalsFilter,
        startDate: dateRangeFilter[0] === null || dateRangeFilter.length === 0 ? "" : dateRangeFilter[0],
        endDate: dateRangeFilter[1] === null || dateRangeFilter.length === 0 ? "" : dateRangeFilter[1],
      };
      // const payload = {
      //   pageNumber: String(pageNumber),
      //   buyers: buyersOptions,
      //   metals: metalsOptions,
      // };
      const res = await getSalesMaterialsService(currOffice, String(pageNumber), filters);
      res.data.materials.forEach((material: any) => {
        material.key = material.materialID;
        // material.buyerInfo = buyersMap[material.saleInfo.buyerID];
        // material.metalInfo = metalsMap[material.metalID];
      });
      setTotalPages(res.data.totalPages);
      setTotalMaterials(res.data.totalMaterials);
      setMaterials(res.data.materials);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getMaterials error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getBuyerDisplayName = (buyerInfo: any) => {
    let buyerDisplayInfo = "";
    if (buyerInfo !== undefined && buyerInfo["companyName"] !== "" && buyerInfo["name"] !== "") {
      buyerDisplayInfo = buyerInfo["companyName"] + " (" + buyerInfo["name"] + ")";
    } else if (buyerInfo !== undefined && buyerInfo["companyName"] !== "") {
      buyerDisplayInfo = buyerInfo["companyName"];
    } else if (buyerInfo !== undefined && buyerInfo["name"] !== "") {
      buyerDisplayInfo = buyerInfo["name"];
    }
    return buyerDisplayInfo;
  };

  const getMaterialExpandedDetails = async (record: any) => {
    try {
      setLoading(true);
      const res = await getSaleService(currOffice, record.saleID);
      const currSale = res.data;
      const currBuyer = buyers.find((buyer: any) => buyer.buyerID === currSale.buyerID);
      let wasteInfo = "(";
      if (record.smallBag > 0) {
        if (record.bigBag > 0) wasteInfo += `${record.smallBag} small, `;
        else wasteInfo += `${record.smallBag} small`;
      }
      if (record.bigBag > 0) {
        if (record.jumboBag > 0) wasteInfo += `${record.bigBag} big, `;
        else wasteInfo += `${record.bigBag} big`;
      }
      if (record.jumboBag > 0) {
        wasteInfo += `${record.jumboBag} jumbo`;
      }
      wasteInfo += ")";

      const newMaterialDetails = [...materialDetailsTableData];
      const newMaterialDetailsObject = {
        ...record,
        ...currSale,
        buyerName: getBuyerDisplayName(currBuyer),
        wasteWeightInfo: wasteInfo,
      };
      newMaterialDetails.push(newMaterialDetailsObject);
      setMaterialDetailsTableData([...newMaterialDetails]);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getMaterialExpandedDetails error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const displayMaterialDetails = (record: any) => {
    const currMaterialDetail = materialDetailsTableData.find(
      (materialDetail: any) => materialDetail.materialID === record.materialID
    );
    return (
      <Row justify="center">
        <Col span={20}>
          <Row style={{ margin: "10px 0" }}>
            <Col span={12}>Buyer: {currMaterialDetail.buyerName}</Col>
          </Row>
          <Row style={{ margin: "10px 0" }}>
            <Col span={12}>Sale Completed: {currMaterialDetail.completed === true ? "Yes" : "No"}</Col>
            <Col span={12}>
              Time:{" "}
              {new Date(currMaterialDetail.createdTimestamp).toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              })}
            </Col>
          </Row>
          <Row style={{ margin: "10px 0" }}>
            <Col span={12}>Raw Weight: {Number(currMaterialDetail.rawWeight).toFixed(1)} kg</Col>
            <Col span={12}>
              Waste Weight: {Number(currMaterialDetail.wasteWeight).toFixed(1)} kg {currMaterialDetail.wasteWeightInfo}
            </Col>
          </Row>
          <Row style={{ margin: "10px 0" }}>
            <Col span={12}>Invoice Issued: {currMaterialDetail.invoiceIssued === false ? "No" : "Yes"}</Col>
            <Col span={12}>
              Invoice Issued Date: {currMaterialDetail.invoiceIssued ? currMaterialDetail.invoiceIssued : "N/A"}
            </Col>
          </Row>
          {currMaterialDetail.notes && (
            <>
              <Row style={{ margin: "10px 0" }}>Notes: {currMaterialDetail.notes}</Row>
            </>
          )}
        </Col>
      </Row>
    );
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const viewSale = (saleID: any) => {
    navigate(`/sale/${saleID}`);
  };

  const confirmFilterMaterials = async () => {
    setIsFilterModalOpen(false);
    await getMaterials(1, buyersSelectedOptions, metalsSelectedOptions, dateRangeFilter);
    setIsFilteredData(true);
  };

  const cancelFilterMaterials = () => {
    setIsFilterModalOpen(false);
  };

  const openFilterModal = () => {
    getBuyersFilterOptions();
    setIsFilterModalOpen(true);
  };

  const resetFilters = async () => {
    setBuyersSelectedOptions("");
    setDateRangeFilter([]);
    setDateRangeValue([null, null]);
    setMetalsSelectedOptions("");
    await getMaterials(1, "", "", []);
    setIsFilterModalOpen(false);
    setIsFilteredData(false);
  };

  const updateBuyerFilter = (value: any) => {
    setBuyersSelectedOptions(value);
  };

  const getSelectedBuyersValue = () => {
    if (buyersSelectedOptions === "") return [];
    return buyersSelectedOptions;
  };

  const getSelectedMetalsValue = () => {
    if (metalsSelectedOptions === "") return [];
    return metalsSelectedOptions;
  };

  const updateDateRangeFilter = (dateRange: string[]) => {
    setDateRangeValue([dayjs(dateRange[0], "YYYY-MM-DD"), dayjs(dateRange[1], "YYYY-MM-DD")]);
    setDateRangeFilter(dateRange);
  };

  const updateMetalFilter = (value: any) => {
    setMetalsSelectedOptions(value);
  };

  return (
    <Layout>
      <Loader loading={loading} />
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Header toggleSidebar={toggleSidebar} />
        <Row justify="center">
          <Col span={22}>
            <Row>
              <Col span={12}>
                <Row justify="start">
                  <h2 className="sales-materials-title">Materials</h2>
                </Row>
              </Col>
              <Col span={12}>
                <Row justify="end">
                  <Button
                    type="default"
                    onClick={() => openFilterModal()}
                    icon={<FilterOutlined />}
                    // icon={<FilterTwoTone />}
                    style={{
                      marginTop: "20px",
                      marginRight: "10px",
                      color: isFilteredData ? "white" : "",
                      backgroundColor: isFilteredData ? "#283555" : "",
                    }}
                  ></Button>
                  <Button
                    type="default"
                    onClick={() => resetFilters()}
                    icon={<ReloadOutlined />}
                    style={{ marginTop: "20px" }}
                  >
                    Reload Data
                  </Button>
                </Row>
              </Col>
            </Row>
            <Divider style={{ margin: "12px 0" }} />
            <Table
              dataSource={[...materials]}
              columns={materialsColumns}
              rowKey={(record: any) => record.key}
              pagination={{
                pageSize: 20,
                total: totalMaterials,
                showSizeChanger: false,
                onChange: (page) => {
                  setCurrentPage(page);
                  getMaterials(page, buyersSelectedOptions, metalsSelectedOptions, dateRangeFilter);
                },
              }}
              expandedRowRender={(record) => displayMaterialDetails(record)}
              expandIcon={({ expanded, onExpand, record }) =>
                expanded ? (
                  <Button type="default" size="small" onClick={(e) => onExpand(record, e)}>
                    Hide Details
                  </Button>
                ) : (
                  <Button
                    type="default"
                    size="small"
                    onClick={async (e) => {
                      await getMaterialExpandedDetails(record);
                      onExpand(record, e);
                    }}
                  >
                    Show Details
                  </Button>
                )
              }
            />
          </Col>
        </Row>
        <Modal
          title="Filter Materials"
          open={isFilterModalOpen}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
          onCancel={cancelFilterMaterials}
        >
          <Row>
            <Col span={24}>
              {/* <Row style={{ marginBottom: "10px" }}>Buyers:</Row>
              <Row style={{ marginBottom: "10px" }}>
                <Select
                  showSearch
                  mode="multiple"
                  allowClear
                  style={{ width: "100%" }}
                  placeholder="Select buyers"
                  value={getSelectedBuyersValue()}
                  onChange={updateBuyerFilter}
                  options={buyersOptions}
                  filterOption={(input: any, option: any) => {
                    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                  }}
                />
              </Row> */}
              <Row style={{ marginBottom: "10px" }}>Metals:</Row>
              <Row style={{ marginBottom: "10px" }}>
                <Select
                  showSearch
                  mode="multiple"
                  allowClear
                  style={{ width: "100%" }}
                  placeholder="Select Metals"
                  value={getSelectedMetalsValue()}
                  onChange={updateMetalFilter}
                  options={metalsOptions}
                  filterOption={(input: any, option: any) => {
                    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                  }}
                />
              </Row>
              <Row style={{ marginBottom: "10px" }}>Date Range:</Row>
              <Row style={{ marginBottom: "10px" }}>
                <RangePicker
                  style={{ width: "100%" }}
                  // defaultValue={[null, null]}
                  // value={[null, null]}
                  value={dateRangeValue}
                  onChange={(value, dateString: string[]) => {
                    updateDateRangeFilter(dateString);
                  }}
                  disabledDate={(current) => {
                    let customDate = moment().add(1, "day").format("YYYY-MM-DD");
                    return current && current > moment(customDate, "YYYY-MM-DD");
                  }}
                />
              </Row>
              <Row justify="center" style={{ margin: "30px 0" }}>
                <Button onClick={() => resetFilters()} style={{ marginRight: "20px" }}>
                  Reset Filters
                </Button>
                <Button type="primary" onClick={() => confirmFilterMaterials()}>
                  Filters Sales
                </Button>
              </Row>
            </Col>
          </Row>
        </Modal>
        <Copyright />
      </Content>
    </Layout>
  );
};

export default SalesMaterialsPage;
